import EditCourseContainer from './EditCourseContainer';

export default EditCourseContainer;